import type { LocalReviewSession } from "./db";
import type { FixtureDescriptor } from "./fixtures";

/**
 * A completed attempt only satisfies the exact PR head that was reviewed.
 * Fixture IDs are deliberately stable across heads, so comparing only the ID
 * would hide a re-review after GitHub requests the reviewer on a newer commit.
 */
export function completedFixtureIdsForCurrentHeads(
  fixtures: FixtureDescriptor[],
  sessions: LocalReviewSession[],
): Set<string> {
  const fixturesById = new Map(fixtures.map((fixture) => [fixture.id, fixture]));
  const completed = new Set<string>();

  for (const session of sessions) {
    if (!session.completedAt) continue;
    const fixture = fixturesById.get(session.fixtureId);
    if (!fixture) continue;
    if (fixture.headSha && fixture.headSha !== session.guideHeadSha) continue;
    completed.add(session.fixtureId);
  }

  return completed;
}

/** Only show the completion reward and stack continuation for its exact head. */
export function completedFixtureForMarker(
  fixtures: FixtureDescriptor[],
  fixtureId: string | null,
  headSha: string | null,
): FixtureDescriptor | undefined {
  if (!fixtureId) return undefined;
  const fixture = fixtures.find((candidate) => candidate.id === fixtureId);
  if (!fixture) return undefined;
  if (fixture.headSha && fixture.headSha !== headSha) return undefined;
  return fixture;
}
